import { defineComponent as g, useTemplateRef as _, inject as h, computed as p, watch as v, createElementBlock as M, openBlock as y, mergeProps as H, unref as r, createVNode as P, withCtx as C, renderSlot as S } from "vue";
import x from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Menu/menu.js";
import { c_menu__content_Height as L } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_menu__content_Height.js";
import { c_menu__content_MaxHeight as w } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_menu__content_MaxHeight.js";
import F, { MenuListInjectionKey as I } from "./MenuList.vue2.js";
import V from "../../helpers/AutoWrap.vue2.js";
import $ from "./MenuItem.vue2.js";
import { useOUIAProps as b } from "../../helpers/ouia.js";
const N = /* @__PURE__ */ g({
  name: "PfMenuContent",
  __name: "MenuContent",
  props: {
    menuHeight: {},
    maxMenuHeight: {},
    onHeight: { type: Function },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(s) {
    const o = s, c = b({ id: o.ouiaId, safe: o.ouiaSafe }), a = _("elRef"), f = h(I, void 0), n = p(() => {
      let e = f, t;
      for (; e !== void 0; )
        t = e, e = e.parentMenu;
      return t;
    }), u = p(() => {
      var t, i, l;
      if (!a.value)
        return;
      let e = a.value.clientHeight;
      if ((t = n.value) != null && t.el.value) {
        const m = getComputedStyle(n.value.el.value), d = parseFloat(m.getPropertyValue("padding-top").replace(/px/g, "")) + parseFloat(m.getPropertyValue("padding-bottom").replace(/px/g, "")) + ((i = n.value.parentMenu) != null && i.el.value ? parseFloat(
          getComputedStyle((l = n.value.parentMenu) == null ? void 0 : l.el.value).getPropertyValue("border-bottom-width").replace(/px/g, "")
        ) : 0);
        e = e + d;
      }
      return e;
    });
    return v(u, () => {
      var e;
      (e = o.onHeight) == null || e.call(o, String(u.value));
    }), (e, t) => (y(), M("div", H(r(c), {
      ref: "elRef",
      class: r(x).menuContent,
      style: {
        [r(L).name]: e.menuHeight,
        [r(w).name]: e.maxMenuHeight
      }
    }), [
      P(V, {
        component: F,
        include: $
      }, {
        default: C(() => [
          S(e.$slots, "default")
        ]),
        _: 3
      })
    ], 16));
  }
});
export {
  N as default
};
